/**
 * [ File :: G_VariableReal.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/child/attr/G_VariableReal.js
 * @목적 : 그리드 타입에서 활용하는 값만 가지고 있는 변수 객체
 * @진행 : 진행 중
 * @주의 :
 * @이슈 :
 * @일자 : 2018.08.17
 * @작성 : Lee Mi Reu
 * @참조 :
 */

import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder'
import B_Unreal     from 'canvas/base/dev/child/base/B_Unreal'
import B_ChildWorld from 'canvas/base/dev/child/base/B_ChildWorld'
import B_Util       from 'canvas/base/dev/util/B_Util'
import B_Define     from 'canvas/base/dev/util/B_Define'
import G_Define     from 'canvas/grid/dev/util/G_Define'

let mix = (superclass) => new MixinBuilder(superclass)

const G_VariableReal = (function () {
    return class extends mix(B_Unreal).with(B_ChildWorld) {
        constructor (obj) {
            super(obj)

            if (typeof obj.value !== 'undefined') this._value = obj.value
            if (typeof obj.min !== 'undefined') this._min = obj.min
            if (typeof obj.max !== 'undefined') this._max = obj.max

            this.isFail = false

            return B_Util.getProtected(this)
        }

        // 게터/세터가 작동을 안 하는 JS 인터프리터에서 사용하기 위한 함수
        getValue () {
            return this.value
        }
        setValue (value) {
            this.value = value
        }
        plusValue (value) {
            this.value = parseInt(this._value) + parseInt(value)
            return this.isFail
        }
        minusValue (value) {
            this.value -= value
        }

        get value () { return this._value }

        set value (value) {
            // 최소값 / 최대값 처리
            if (this._min !== null && this._min > value) value = this._min
            else if (this._max !== null && this._max < value) value = this._max

            // 값이 바뀔 때마다 솔루션 처리
            const STATE = this.CODMOS.WORLD.STATE
            const HERO = this.CODMOS.WORLD.hero

            // 모든 변수 실시간 솔루션
            const LIVE_SOLUTION = this.CODMOS.WORLD.LIST[B_Define.VARIABLE_SOLUTION_TYPE]

            let isFail = false

            // 솔루션 목록이 있으면
            if (typeof LIVE_SOLUTION === 'object') {
                // 솔루션을 하나씩 돌려서
                const LIVE_SOLUTION_ARR = Object.values(LIVE_SOLUTION)

                for (let i = 0; i < LIVE_SOLUTION_ARR.length; i++) {
                    const SOLUTION = LIVE_SOLUTION_ARR[i]
                    const SOLUTION_RESULT = SOLUTION._compareVariable(this, value)

                    // 솔루션을 통과 못 하고, 성공 솔루션이 아니면
                    if (SOLUTION_RESULT === false && SOLUTION._success !== true) {
                        // for문 그만 돌고 실패 처리
                        isFail = true
                        STATE.going(B_Define.CLEAR_STATUS['FAIL'], G_Define.REASON['VARIABLE'], null)
                        break
                    }
                    // 예외가 발생 안 하고, 성공 솔루션이면
                    else if (SOLUTION_RESULT === true && SOLUTION._success === true) {
                        // for문 그만 돌리고 성공 처리
                        STATE.going(B_Define.CLEAR_STATUS['SUCCESS'], B_Define.REASON['SUCCESS'], this)
                        break
                    }
                }
            }

            // 미션 실패가 발생 안 했으면 변수 객체에 value 반영
            if (isFail === false) this._value = value

            HERO._endAction()

            this.isFail = isFail
        }
    }
}())

export default G_VariableReal



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/attr/G_VariableReal.js